import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, url = "https://a2zsigns.co", type = "website" }) => {
  // We append the company name to the end of every title automatically
  const fullTitle = `${title} | A2Z Signs`;

  return (
    <Helmet>
      {/* The Title tag that shows up in the browser tab and Google search */}
      <title>{title ? `${title} | A2Z Signs` : 'A2Z Signs | Custom Commercial Signage'}</title>

      {/* The Description tag for the Google search snippet */}
      {description && <meta name="description" content={description} />}

      {/* The Keywords tag */}
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph Tags (For Facebook, LinkedIn, iMessage previews) */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;